import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=20350f7a&scoped=true"
import script from "./StatisticCard.vue?vue&type=script&lang=ts"
export * from "./StatisticCard.vue?vue&type=script&lang=ts"
import style0 from "./StatisticCard.vue?vue&type=style&index=0&id=20350f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20350f7a",
  null
  
)

export default component.exports